import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const REGISTER_FORM_URL = 'https://forms.office.com/Pages/ResponsePage.aspx?id=GIlUwqulxkW2gUlR5VePC12nZ4fz5yRFkrQsWYzu1nBUN01NTlFFS0lQOFhRNjk4MDVaQloxTkJBRS4u';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // Update layout on resize
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) setMobileMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleRegisterRedirect = () => {
    window.open(REGISTER_FORM_URL, '_blank', 'noopener,noreferrer');
    setMobileMenuOpen(false);
  };

  return (
    <header style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: isMobile ? '0 15px' : '0 6%',
      height: '80px',
      background: '#000',
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 1000,
      borderBottom: '1px solid rgba(255,255,255,0.1)'
    }}>
      {/* Logo Link with SEO alt text */}
      <Link to="/" style={{ display: 'flex', alignItems: 'center' }} aria-label="Ciqura Labs Home">
        <img
          src="https://res.cloudinary.com/dlz8euavh/image/upload/c_crop,w_560,h_200/v1767175729/6-removebg-preview_rm41rl.png"
          alt="Ciqura Labs - Best Cybersecurity Training in Indore"
          style={{ height: isMobile ? '40px' : '60px', objectFit: 'contain' }}
          fetchpriority="high" // 🔹 Boosts LCP performance score
        />
      </Link>

      {/* DESKTOP NAV (Hidden on Mobile) */}
      {!isMobile && (
        <nav style={{ display: 'flex', alignItems: 'center', gap: '30px' }} aria-label="Main Navigation">
          <Link to="/" className="dark-nav-link">Home</Link>
          <Link to="/about" className="dark-nav-link">About</Link>
          <Link to="/programs" className="dark-nav-link">Programs</Link>
          <Link to="/internship" className="dark-nav-link">Internship</Link>
          <Link to="/contact" className="dark-nav-link">Contact</Link>
          <Button className="btn-primary" onClick={handleRegisterRedirect}>
            Register Now
          </Button>
        </nav>
      )}

      {/* MOBILE MENU BUTTON (Only visible on Mobile) */}
      {isMobile && (
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-expanded={mobileMenuOpen}
          aria-label="Toggle Mobile Menu"
          style={{
            background: 'none',
            border: 'none',
            color: 'var(--brand-primary, #3fffe0)',
            cursor: 'pointer',
            padding: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1100
          }}
        >
          {mobileMenuOpen ? <X size={32} /> : <Menu size={32} />}
        </button>
      )}

      {/* MOBILE DROPDOWN MENU */}
      {isMobile && mobileMenuOpen && (
        <nav style={{
          position: 'fixed',
          top: '80px',
          left: 0,
          right: 0,
          bottom: 0,
          background: '#000',
          display: 'flex',
          flexDirection: 'column',
          padding: '40px 20px',
          gap: '25px',
          zIndex: 999,
          overflowY: 'auto'
        }} aria-label="Mobile Navigation">
          <Link to="/" style={mobileLinkStyle} onClick={() => setMobileMenuOpen(false)}>Home</Link>
          <Link to="/about" style={mobileLinkStyle} onClick={() => setMobileMenuOpen(false)}>About</Link>
          <Link to="/programs" style={mobileLinkStyle} onClick={() => setMobileMenuOpen(false)}>Programs</Link>
          <Link to="/internship" style={mobileLinkStyle} onClick={() => setMobileMenuOpen(false)}>Internship</Link>
          <Link to="/contact" style={mobileLinkStyle} onClick={() => setMobileMenuOpen(false)}>Contact</Link>
          
          <Button 
            className="btn-primary" 
            onClick={handleRegisterRedirect}
            style={{ width: '100%', padding: '15px', marginTop: '10px', fontSize: '18px' }}
          >
            Register Now
          </Button>
        </nav>
      )}
    </header>
  );
};

const mobileLinkStyle = {
  color: '#fff',
  fontSize: '22px',
  textDecoration: 'none',
  borderBottom: '1px solid rgba(255,255,255,0.1)',
  paddingBottom: '10px',
  fontWeight: '500'
};

export default Header;